<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="plan-estudio" titulo="Plan de estudio/ Coordinación escolar" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('carreras', 'carrera');"></a>
                    <a id="message" (click)="ctrl.mostrar_mensaje(titulo, mensaje, clase);"></a>

                    <div class="columns">
                        <div class="column">
                            <label class="label">Nombre:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required')}" placeholder="Nombre" formControlName="nombre">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required')">
                                  <i class="fa fa-warning"></i>
                              </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>

                        <div class="column is-4">
                            <br><br>
                            <div class="b-checkbox is-info">
                                <input id="activo" class="styled" [checked]="ctrl.dato.get('activo').value == '1' ? true : false" (change)="ctrl.dato.get('activo').patchValue(ctrl.dato.get('activo').value == '1' ? '0' : '1')" type="checkbox">
                                <label for="activo">
                                  Activo
                              </label>
                            </div>
                        </div>
                    </div>




                    <nav class="panel">
                        <section class="hero is-light">
                            <div class="hero-head">
                                <nav class="level">
                                    <!-- Left side -->
                                    <div class="level-left">
                                        <div class="level-item">
                                            <p class="title is-4" style=" padding-left: 10px; ">
                                                <span class="icon is-medium">
                                                    <i class="icon-list "></i>
                                                </span> Lista de carreras que conforman el plan de estudios
                                            </p>
                                        </div>


                                    </div>

                                    <!-- Right side -->
                                    <div class="level-right">

                                        <a class="navbar-item  tooltip" (click)="ctrl.agregar_form_array(ctrl.dato.controls.carreras_planes, form_carreras_planes)">
                                            <span class="icon has-text-success">
                                                <i class="icon-add2"></i>
                                            </span>
                                            <span class="tooltiptext">Agregar</span>
                                        </a>

                                        <!-- <a class="navbar-item  tooltip" (click)="defaultMetodo(ctrl.dato.controls.carreras_planes)">
                                            <span class="icon has-text-info">
                                                <i class="icon-file"></i>
                                            </span>
                                            <span class="tooltiptext">Métodos Default</span>
                                        </a> -->

                                        <!-- <a class="navbar-item  tooltip" (click)="quitarAllMetodo()">
                                            <span class="icon has-text-danger">
                                                <i class="icon-trash"></i>
                                            </span>
                                            <span class="tooltiptext">Limpiar lista</span>
                                        </a> -->
                                    </div>
                                </nav>
                            </div>
                        </section>
                        <div class="panel-block">
                            <div formArrayName="carreras_planes">
                                <div *ngFor="let item of ctrl.dato.controls.carreras_planes.controls; let i=index" class="column" style="min-width:350px; width:49.0%; float:left">
                                    <nav class="panel" [formGroupName]="i">
                                        <div class="panel-heading">
                                            <label class="label is-10">Carrera {{i+1}} </label>
                                            <!-- <input class="input" style="background-color: transparent !important; border: 0px;" type="text" placeholder="xxx">
                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.carreras_planes.controls[i].controls.nombre.valid"> </span> -->
                                            <a style="float:right; margin-top: -25px;" class="is-danger is-2" (click)="ctrl.quitar_form_array(ctrl.dato.controls.carreras_planes, i)">
                                                <span class="icon has-text-danger">
                                                    <i class="icon-trash"></i>
                                                </span>
                                            </a>
                                        </div>
                                        <label class="panel-block">
                                        <div class="select">
                                            <select class="select" name="carreras_id" formControlName="carreras_id" (change)="descartar($event, ctrl.carreras, i)">
                                                <option *ngFor="let val of ctrl.carreras" value="{{val.id}}">[ {{ val.rvoe }} ] {{ val.nombre }}</option>
                                            </select>
                                        </div>
                                        </label>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </nav>

                </section>
            </form>
        </div>
    </div>
</div>
